<template lang="html">
  <StandardDialog @click-outside="$router.push({ name: 'AccountSettings'})">
    <template #content>
      <StandardTextCard
        height="74vh"
        :name="$t('Account.Upgrade.UpgradeFullUser')"
        :clickable="false"
      >
        <template #info>
          <v-form>
            <v-subheader class="title">{{$t('Account.AccountSettings.Upgrade.TaktProject.Header')}}</v-subheader>
            <v-text-field v-model="information.project.name" :label="$t('Account.AccountSettings.Upgrade.TaktProject.Values[0]')" type="text"></v-text-field>
            <v-text-field v-model="information.project.description" :label="$t('Account.AccountSettings.Upgrade.TaktProject.Values[1]')" type="text"></v-text-field>
            <v-subheader class="title">{{$t('Account.AccountSettings.Upgrade.TaktExperience.Header')}}</v-subheader>
            <v-text-field v-model="information.experience.years" :label="$t('Account.AccountSettings.Upgrade.TaktExperience.Values[0]')" type="number" min="0"></v-text-field>
            <v-text-field v-model="information.experience.projects" :label="$t('Account.AccountSettings.Upgrade.TaktExperience.Values[1]')" type="number" min="0"></v-text-field>
          </v-form>
        </template>
        <template #actions>
          <v-btn color="blue" text @click="requestUpgrade()">{{$t('Account.AccountSettings.Upgrade.UpgradeNow')}}</v-btn>
          <v-btn color="red" text @click="$router.push({ name: 'AccountSettings'})">{{$t('Buttons.Cancel')}}</v-btn>
        </template>
      </StandardTextCard>
    </template>
  </StandardDialog>
</template>

<script>
import StandardTextCard from '@/components/StandardComponents/StandardTextCard.component.vue';
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  name: 'AccountSettingsUserUpgradeFullUser',
  components: {
    StandardTextCard, StandardDialog
  },
  data: function() {
    return {
      information: {
        type: 'FullUser',
        project: {
          name: '',
          description: ''
        },
        experience: {
          years: 0,
          projects: 0
        }
      }
    }
  },
  computed: {
    ...mapGetters('Auth', [
      'getUser'
    ])
  },
  methods: {
    ...mapActions('User', [
      'requestUserUpgrade'
    ]),
    requestUpgrade(){
      this.requestUserUpgrade({
          'requested_role': 4,
          'information': this.information
        });
    }
  }
}
</script>

<style lang="css" scoped>
</style>
